import { StyledInfoBox } from './showpad-delay-info-box.style';
import { InfoIcon } from '../icons-library/info';
import theme from '../../style/theme';

type ShowpadDelayInfoBoxProps = {
    text: string; 
    withoutPadding?: boolean;
};

export const ShowpadDelayInfoBox = (props: ShowpadDelayInfoBoxProps) => {
    return (
        <div>
            <StyledInfoBox withoutPadding={props.withoutPadding}>
                <InfoIcon
                    width="2rem"
                    height="2rem"
                    stroke={theme.palette.lightGray}
                />
                <div class="text-small" style={{ 'width': 'fit-content' }}>{props.text}</div>
            </StyledInfoBox>
        </div>
    );
};

